var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "road__x2C__sign__x2C__alert__x2C__danger__x2C_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 16,
    x2: 496,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D59632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0068,
    style: {
      stopColor: "#D79B32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0456,
    style: {
      stopColor: "#DFB434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0893,
    style: {
      stopColor: "#E6C735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    style: {
      stopColor: "#EAD535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2032,
    style: {
      stopColor: "#EDDD36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3214,
    style: {
      stopColor: "#EEDF36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#EEDF36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    style: {
      stopColor: "#EDDD36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    style: {
      stopColor: "#EBD535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    style: {
      stopColor: "#E6C735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#DFB434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    style: {
      stopColor: "#D79C32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D59632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.968,72.905L24.872,373.97    c-25.111,43.188,6.073,97.35,55.997,97.35h350.264c49.923,0,81.103-54.161,55.997-97.35L312.042,72.905    C287.002,29.939,225,29.939,199.968,72.905L199.968,72.905z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 256.0078,
    cy: 225.9443,
    gradientTransform: "matrix(6.8138 0 0 6.8138 -1488.3801 -1283.6067)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    r: 28.7356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D4148"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.062,439.26H83.944    c-12.813,0-24.303-6.658-30.67-17.787c-6.441-11.121-6.367-24.373,0.074-35.503L225.37,90.184    c6.438-10.981,17.853-17.575,30.596-17.575c12.813,0,24.229,6.594,30.675,17.575L458.657,385.97    c6.447,11.13,6.513,24.382,0.075,35.503C452.36,432.602,440.87,439.26,428.062,439.26L428.062,439.26z M255.966,88.134    c-7.179,0-13.614,3.653-17.203,9.877L66.739,393.806c-3.658,6.223-3.658,13.691-0.068,19.911    c3.659,6.299,10.099,10.026,17.273,10.026h344.118c7.17,0,13.614-3.728,17.271-10.026c3.588-6.22,3.514-13.688-0.075-19.911    L273.239,98.011C269.661,91.787,263.211,88.134,255.966,88.134L255.966,88.134z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 256.0078,
    cy: 229.458,
    gradientTransform: "matrix(6.8138 0 0 6.8138 -1488.3801 -1283.6067)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    r: 11.1161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D4148"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.351,306.704V174.579h39.308v132.125H236.351    L236.351,306.704z M236.351,385.173v-44.359h39.308v44.359H236.351z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_3_)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.a060c4d21a15cc52534bdaeb7b745701.svg";
export { ForwardRef as ReactComponent };